import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'entering:animate-in entering:fade-in exiting:animate-out exiting:fade-out z-50 max-h-60 w-(--menu-width) overflow-auto bg-white p-3 shadow-[0_4px_11px_0_rgba(29,31,34,0.1)]',
    listbox: 'outline-hidden',
    option:
      'data-[focus=true]:bg-bg-items-white focus:bg-bg-items-white hover:bg-bg-items-white heading-s flex cursor-default items-center gap-0.5 px-4 py-3 select-none'
  },
  variants: {
    isEmpty: {
      true: {
        base: 'hidden'
      }
    }
  }
});
